import React from 'react'
import Confetti from 'react-confetti'

import { CommonSvgContent } from "./CommonSvgContent"
import { ContentRoom3 } from "./ContentRoom3"
import { Balloon } from "./Balloon"
import { Help } from "./Help"

import { Clock } from "./Clock"
import "./../assets/scss/Room3.scss";


export const Room3 = (props) => {
  const steps = {
    "b_intro" : ["intro", "close"],
    "f_marge1" : null,
    "b_marge1a": ["centerr", "follow"],
    "b_marge1b": ["centerr", "follow"],
    "b_marge1c": ["centerr", "close"],
    "f_diario" : null,
    "b_diario": ["image link", "close"],
    "f_marge2" : null,
    "b_marge2a": ["centerr", "follow"],
    "risposta1": null,
    "f_map" : "",
    "b_map" : ["image link", "close"],
    "f_marge3" : null,
    "b_marge3a": ["centerr", "follow"],
    "b_marge3b": ["centerr", "close"],
    "risposta2": null,
    "b_exit" : ["exit", ""]
  };

  React.useEffect(() => {
    if(props.step == Object.keys(steps).indexOf("risposta1")) props.onNextHelp();
    if(props.step == (Object.keys(steps).indexOf("risposta1") + 1)) props.onNextHelp(0);
    if(props.step == Object.keys(steps).indexOf("risposta2")) props.onNextHelp(4);
    if(props.step == (Object.keys(steps).indexOf("risposta2") + 1)) props.onNextHelp(0);
  }, [props.step]);

    const books1 = [];
    const books2 = [];

    for (let i = 0; i < 12; i++) {
      books1.push(<div className="book" key={i}  />);
    }

    for (let i = 0; i < 10; i++) {
      books2.push(<div className="book" key={i}  />);
    }

    return(
      <div className="room3">

        <div className="parete">
          <div className="libreria libreriaL">
            <div className="scaffale1"><div className="books books1">{books1}</div></div>
            <div className="scaffale2"><div className="books books2">{books1}</div></div>
            <div className="scaffale3"><div className="books books3">{books1}</div></div>
            <div className="scaffale4"><div className="books books4">{books1}</div></div>

            <div className="scaffale5"><div className="books books5">{books1}</div></div>

            <div className="scaffale6"><div className="books books6">{books1}</div></div>

            <div className="spallaDx"></div>
            <div className="zoccolo"></div>
          </div>

          <div className="libreria libreriaR">
            <div className="scaffale1"><div className="books books1">{books1}</div></div>
            <div className="scaffale2"><div className="books books2">{books1}</div></div>
            <div className="scaffale3">
              <div className="books books3">{books2}</div>

              <button className={`diario ${(props.step >= Object.keys(steps).indexOf("f_diario") && props.step <= Object.keys(steps).indexOf("risposta1")) ? "active" : "unactive"}`}
                      onClick={() => props.step >= Object.keys(steps).indexOf("f_diario")  && props.step <= Object.keys(steps).indexOf("risposta1") ? props.onChangeStep(Object.keys(steps).indexOf("b_diario")) : false } >

                <div className="bollino">diario</div>
                <img src={require('../assets/images/dicario-chiuso.png')} alt="" />


                {(props.step == Object.keys(steps).indexOf("f_diario")) &&
                  <CommonSvgContent stringToRet="click" />
                }
                {(props.step > Object.keys(steps).indexOf("f_diario")  && props.step <= Object.keys(steps).indexOf("risposta1")) &&
                  <div className="clickable" />
                }
              </button>
            </div>
            <div className="scaffale4"><div className="books books4">{books1}</div></div>

            <div className="scaffale5"><div className="books books5">{books1}</div></div>

            <div className="scaffale6"><div className="books books6">{books1}</div></div>

            <div className="spallaDx"></div>
            <div className="zoccolo"></div>
          </div>
        </div>
        <div className="pavimento">
          <ContentRoom3 stringToRet="pavimento" />
        </div>

        <button className={`map ${(props.step >= Object.keys(steps).indexOf("f_map")) ? "active" : "unactive"}`}
                onClick={() => props.step >= Object.keys(steps).indexOf("f_map") ? props.onChangeStep(Object.keys(steps).indexOf("b_map")) : false } >
          {(props.step == Object.keys(steps).indexOf("f_map")) &&
            <CommonSvgContent stringToRet="click" />
          }
          {(props.step > Object.keys(steps).indexOf("f_map")) &&
            <div className="clickable" />
          }
          <img src={require('../assets/images/mars_s.png')} alt="" />
        </button>



        <div className='pianta'>
          <CommonSvgContent stringToRet="pianta" />
        </div>



        <div className={`areaTelefono ${(props.step == Object.keys(steps).indexOf("risposta1") || props.step == Object.keys(steps).indexOf("risposta2")) ? "help3 ringing" : ""}`}>
          <div className="pianoUnder" />
          <div className="pianoOver">
            <div className="telefono">
              <CommonSvgContent stringToRet="telefono" />
            </div>

            <div className="helpsWrapper">
              <div className="helps">
                <button className="helpclick1 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 1) :
                                                                      (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 4) : false }>1</button>
                <button className="helpclick2 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 2) :
                                                                      (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 5) : false }>2</button>
                <button className="helpclick3 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 3) :
                                                                      (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 6) : false }>3</button>
              </div>
            </div>
          </div>
        </div>


        <button
          className={`marge ${(props.step >= Object.keys(steps).indexOf("f_marge1")) ? "active" : "unactive"}`}
          onClick={() => props.step >= Object.keys(steps).indexOf("f_marge1") &&  props.step < Object.keys(steps).indexOf("f_marge2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1a")) :
                         props.step >= Object.keys(steps).indexOf("f_marge2") &&  props.step <= Object.keys(steps).indexOf("risposta1") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge2a")) :
                         props.step >= Object.keys(steps).indexOf("f_marge3") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge3a")) : false } >
          {(props.step == Object.keys(steps).indexOf("f_marge1") || props.stepnow == Object.keys(steps).indexOf("f_marge2") || props.stepnow == Object.keys(steps).indexOf("f_marge3")) &&
            <CommonSvgContent stringToRet="click" />
          }
          {(props.step > Object.keys(steps).indexOf("f_marge1") && props.step < Object.keys(steps).indexOf("f_marge2") ||
            props.step > Object.keys(steps).indexOf("f_marge2") && props.step <= Object.keys(steps).indexOf("risposta1") ||
            props.step > Object.keys(steps).indexOf("f_marge3") && props.step <= Object.keys(steps).indexOf("risposta2")) &&
            <div className="clickable" />
          }
          <CommonSvgContent stringToRet="marge" />
        </button>


        {(props.step >= Object.keys(steps).indexOf("risposta1") && props.step < (Object.keys(steps).indexOf("risposta1") + 1)) &&
          <div className="risposta">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}
            {(props.answerfeedback == "right") && (
              <>
                <p>BEN FATTO! Hai risolto l'enigma</p>
                <Confetti />
              </>
            )}
            {(props.answerfeedback !== "right") && (
              <div className="rispostaCont">
                <form onSubmit={(e) => props.onSubmitAnswer(e, "room3a", Object.keys(steps).indexOf("risposta1"))}>
                  <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                  <input type="submit" value="OK" />
                </form>
                <p>19 caratteri MAIUSCOLI senza spazi </p>
              </div>
            )}
          </div>
        }

        {(props.step >= Object.keys(steps).indexOf("risposta2") && props.step < (Object.keys(steps).indexOf("risposta2") + 1)) &&
          <div className="risposta coordinate">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}

            <div className="rispostaCont">
              <form onSubmit={(e) => props.onSubmitAnswer(e, "room3b", Object.keys(steps).indexOf("risposta2"))}>
                <label>Latitudine Sud compresa tra…</label>
                <input type="text" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                <span>e</span>
                <input type="text" value={props.answer2} onChange={(e) => props.onChangeAnswer(e,2)} />
                <label>Longitudine compresa tra…</label>
                <input type="text" value={props.answer3} onChange={(e) => props.onChangeAnswer(e,3)} />
                <span>e</span>
                <input type="text" value={props.answer4} onChange={(e) => props.onChangeAnswer(e,4)} />

                <input type="submit" value="OK" />
              </form>
            </div>
          </div>
        }

        {(props.helpopen != 0) &&
          <Help room={props.room} clickon={`help${props.helpopen}`} onNextHelp={props.onNextHelp} />
        }

        {(Object.keys(steps).length > props.stepnow && Object.keys(steps)[props.stepnow].startsWith("b_")) &&
          <Balloon type={steps[Object.keys(steps)[props.stepnow]][0]} room={props.room} clickon={Object.keys(steps)[props.stepnow]} button={steps[Object.keys(steps)[props.stepnow]][1]} interaction={false} onChangeStep={props.onChangeStep} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
        }
      </div>
    )
}
